export default __webpack_public_path__ + "static/media/winline_loyalty_1.b0fc5e66.png";